·<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     介绍
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="flex-center">
    <el-card v-loading="loading" class="mt-md" :body-style="{ margin: '100px 100px', width: '1080px' }" shadow="never">
      <div class="flex flex-center bg-light radius5 pl pr pt pb">
        <div class="hd font-4x text-primary">
          <i class="iconfont icon-Datav"></i>
        </div>
        <div class="bd ml">
          <div class="font-lg">{{ module.title }}</div>
          <div class="mt-xs text-muted">{{ status === 1 ? '已开通' : '未开通' }}</div>
        </div>
        <div class="ft flex-center">
          <template v-if="status === 3">
            <div class="font-4x text-danger">
              <i class="iconfont icon-circle-error"></i>
            </div>
            <div class="font-lg text-danger">审核不通过</div>
            <el-button class="ml" type="success" :loading="posting" @click="apply">重新申请</el-button>
          </template>
          <template v-else-if="status === 2">
            <div class="font-4x text-blue">
              <i class="iconfont icon-clock"></i>
            </div>
            <div>
              <div class="font-lg text-blue">正在审核中</div>
              <div class="text-muted">{{ god_module.applytime | parseTime('{y}/{m}/{d}') }} 提交申请</div>
            </div>
          </template>
          <template v-else-if="status === 1">
            <div class="font-4x text-success">
              <i class="iconfont icon-circle-check"></i>
            </div>
            <span class="font-lg text-success">开通成功</span>
          </template>
          <template v-else>
            <el-button type="success" :loading="posting" @click="apply">申请开通</el-button>
          </template>
        </div>
      </div>

      <div class="mt-lg ml mr">
        <div>
          <span class="font-lg middle text-warning"><i class="el-icon-goods"></i></span>
          <span class="ml-sm">开通条件</span>
        </div>
        <ul class="text-muted">
          <li><p>设备厂商、经销商、代理商可以开通此功能</p></li>
        </ul>
      </div>

      <div class="mt-lg ml mr">
        <div>
          <span class="font-lg middle text-blue"><i class="el-icon-help"></i></span>
          <span class="ml-sm">功能介绍</span>
        </div>
        <p class="text-muted">「数据可视化」功能模块，能够实时感知所有设备的态势，集中监控所有设备的运行情况。监控大屏中主要以下信息：</p>
        <ul class="text-muted">
          <li><p>设备的全国地图分布信息</p></li>
          <li><p>设备的在线、运行、告警汇总，及最新事件信息</p></li>
          <li><p>用户使用远程监控功能的活跃度，及最新访问信息</p></li>
        </ul>
        <p class="text-center"><img src="@/assets/datav.jpg"></p>
      </div>
    </el-card>
  </div>
</template>

<script>
import { moduleOpenStatus, moduleOpenApply } from '@/api/common/moduleApi'
export default {
  components: {
  },
  data() {
    return {
      loading: false,
      posting: false,
      module: {},
      god_module: {},
      status: null
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      moduleOpenStatus({ module: 'Datav' }).then(res => {
        this.loading = false
        if (!res.errno) {
          this.module = Object.assign({}, res.data.module)
          this.god_module = Object.assign({}, res.data.god_module)
          this.status = res.data.god_module.status || 0

          // 若模块已开通，提示后，刷新页面
          if (this.status === 1) {
            this.$message({
              message: '模块开通成功',
              type: 'success',
              onClose() {
                window.location.reload()
              }
            })
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    apply() {
      this.$confirm(`将申请开通 <span class="text-primary">${this.module.title}</span> 功能模块，是否继续？`, '提示', {
        dangerouslyUseHTMLString: true,
        type: 'success'
      }).then(() => {
        this.posting = true
        moduleOpenApply({ module: 'Datav' }).then(res => {
          this.posting = false
          if (!res.errno) {
            this.fetchData()
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
      })
    }
  }
}
</script>
